import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(false);
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [state, setState] = useAggregatedState({
        roles: null
    });

    const apiClient = useContext(RestApiContext);

    const getRolesAsync = async (onlyManagement, withUsers) => {
        try {
            const roles = await apiClient.getRolesAsync(onlyManagement, withUsers);
            setState({ roles });
        } catch(e) {
            console.debug(e);
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getRolesAsync,
        }}>
            {props.children}
        </Provider>
    );
}